/**
 * Extends the WeakMap to return a default object when none is found in the map.
 */
export class WeakDefaultMap<K extends Object, V> extends WeakMap<K, V> {
    make: () => V;

    constructor(make: () => V) {
        super();
        this.make = make;
    }

    get = (key: K): V => {
        if(this.has(key)) {
            return super.get(key) as V;
        } else {
            const value = this.make();
            this.set(key, value);
            return value;
        }
    }
}

export default WeakDefaultMap;
